module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/ML-575d72019dd5350d77bc1fcb649a6678.png";